export default __webpack_public_path__ + "static/engagement-5804fe4ed296f41ba66426a801c13b3e.png";